// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/KioskDisplayPage.css */

.kiosk-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 48px 32px;
  text-align: center;
}

.kiosk-idle {
  justify-content: center;
  gap: 18px;
}

.kiosk-brand {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 12px;
}

.kiosk-brand-logo {
  height: 56px;
  width: 56px;
  object-fit: contain;
  filter: drop-shadow(0 4px 14px rgba(255, 122, 61, 0.4));
}

.kiosk-brand-word {
  font-family: var(--font-display);
  font-size: 32px;
  font-weight: 600;
  color: var(--text);
}

.kiosk-brand-word .accent {
  background: linear-gradient(120deg, var(--accent-start), var(--accent-end));
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.kiosk-idle-title {
  font-size: clamp(24px, 2vw, 32px);
  max-width: none;
  white-space: nowrap;
}

.kiosk-idle-steps {
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: var(--text-muted);
  font-size: 18px;
  max-width: 46ch;
  margin: 0 0 12px;
  padding-left: 0;
  list-style-position: inside;
  text-align: left;
}

.kiosk-idle-steps li {
  line-height: 1.5;
}

.kiosk-qr-frame {
  padding: 28px;
  background: var(--surface);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  line-height: 0;
}

.kiosk-active {
  justify-content: flex-start;
  gap: 8px;
}

.kiosk-active-header {
  margin-bottom: 12px;
}

.kiosk-eyebrow {
  text-transform: uppercase;
  letter-spacing: 0.14em;
  font-size: 13px;
  color: var(--accent);
  margin: 0 0 6px;
}

.kiosk-nickname {
  font-size: clamp(36px, 5vw, 56px);
  text-wrap: balance;
}

.kiosk-queue-note {
  color: var(--text-faint);
  font-size: 14px;
  margin: 6px 0 0;
}

.kiosk-staff-link {
  margin-top: 28px;
  font-size: 12px;
  color: var(--text-faint);
  letter-spacing: 0.04em;
}

.kiosk-staff-link:hover {
  color: var(--text-muted);
}

.kiosk-results-idle {
  margin-top: 12vh;
}

.kiosk-results {
  width: 100%;
}

.kiosk-results .movie-grid.wrap {
  justify-content: center;
}

.kiosk-page.panel-open {
  padding-right: 360px;
}

.kiosk-panel-toggle {
  position: fixed;
  top: 50%;
  right: 0;
  z-index: 30;
  transform: translateY(-50%);
  writing-mode: vertical-rl;
  padding: 16px 10px;
  border: 1px solid var(--border-strong);
  border-right: none;
  border-radius: var(--radius-md) 0 0 var(--radius-md);
  background: var(--surface);
  color: var(--text);
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  cursor: pointer;
}

.kiosk-panel-toggle.open {
  right: 320px;
  writing-mode: horizontal-tb;
  padding: 8px 12px;
}

.kiosk-panel-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  margin-top: 8px;
  padding: 0 5px;
  border-radius: var(--radius-full);
  background: linear-gradient(120deg, var(--accent-start), var(--accent-end));
  color: #1a0e05;
  font-size: 11px;
  writing-mode: horizontal-tb;
}

.kiosk-panel {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 25;
  width: 320px;
  height: 100vh;
  height: 100dvh;
  padding: 22px 18px 28px;
  background: var(--bg-elevated);
  border-left: 1px solid var(--border);
  box-shadow: var(--shadow-lg);
  transform: translateX(100%);
  transition: transform 0.2s var(--ease);
  overflow-y: auto;
  text-align: left;
}

.kiosk-panel.open {
  transform: translateX(0);
}

.kiosk-panel-head h2 {
  margin: 0 0 4px;
  font-size: 20px;
}

.kiosk-panel-head p {
  margin: 0 0 18px;
  color: var(--text-muted);
  font-size: 13px;
}

.kiosk-panel-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 22px;
}

.kiosk-panel-primary,
.kiosk-panel-danger,
.kiosk-panel-row button {
  border: none;
  cursor: pointer;
  font-weight: 600;
}

.kiosk-panel-primary {
  padding: 12px 14px;
  border-radius: var(--radius-full);
  background: linear-gradient(120deg, var(--accent-start), var(--accent-end));
  color: #1a0e05;
  font-size: 14px;
}

.kiosk-panel-danger {
  padding: 10px 14px;
  border-radius: var(--radius-full);
  background: var(--dislike-soft);
  color: var(--dislike);
  font-size: 13px;
}

.kiosk-panel-primary:disabled,
.kiosk-panel-danger:disabled,
.kiosk-panel-row button:disabled {
  opacity: 0.5;
  cursor: default;
}

.kiosk-panel-section {
  margin-bottom: 20px;
}

.kiosk-panel-section h3 {
  margin: 0 0 8px;
  font-size: 12px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-faint);
}

.kiosk-panel-empty {
  margin: 0;
  color: var(--text-faint);
  font-size: 13px;
}

.kiosk-panel-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid var(--border);
}

.kiosk-panel-row.current strong {
  color: var(--accent);
}

.kiosk-panel-row div {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.kiosk-panel-row strong {
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.kiosk-panel-row span {
  font-size: 12px;
  color: var(--text-faint);
}

.kiosk-panel-row button {
  flex-shrink: 0;
  padding: 6px 10px;
  border-radius: var(--radius-full);
  background: var(--surface-hover);
  color: var(--text);
  font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/KioskDisplayPage.css"],"names":[],"mappings":"AAAA,mCAAmC;;AAEnC;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2EAA2E;EAC3E,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,sCAAsC;EACtC,+BAA+B;EAC/B,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;EACtC,kBAAkB;EAClB,oDAAoD;EACpD,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,cAAc;EACd,iCAAiC;EACjC,2EAA2E;EAC3E,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,8BAA8B;EAC9B,oCAAoC;EACpC,4BAA4B;EAC5B,2BAA2B;EAC3B,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;;EAGE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,2EAA2E;EAC3E,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,+BAA+B;EAC/B,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;;EAGE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iCAAiC;EACjC,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":["/* src/pages/KioskDisplayPage.css */\n\n.kiosk-page {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 48px 32px;\n  text-align: center;\n}\n\n.kiosk-idle {\n  justify-content: center;\n  gap: 18px;\n}\n\n.kiosk-brand {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  margin-bottom: 12px;\n}\n\n.kiosk-brand-logo {\n  height: 56px;\n  width: 56px;\n  object-fit: contain;\n  filter: drop-shadow(0 4px 14px rgba(255, 122, 61, 0.4));\n}\n\n.kiosk-brand-word {\n  font-family: var(--font-display);\n  font-size: 32px;\n  font-weight: 600;\n  color: var(--text);\n}\n\n.kiosk-brand-word .accent {\n  background: linear-gradient(120deg, var(--accent-start), var(--accent-end));\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n}\n\n.kiosk-idle-title {\n  font-size: clamp(24px, 2vw, 32px);\n  max-width: none;\n  white-space: nowrap;\n}\n\n.kiosk-idle-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  color: var(--text-muted);\n  font-size: 18px;\n  max-width: 46ch;\n  margin: 0 0 12px;\n  padding-left: 0;\n  list-style-position: inside;\n  text-align: left;\n}\n\n.kiosk-idle-steps li {\n  line-height: 1.5;\n}\n\n.kiosk-qr-frame {\n  padding: 28px;\n  background: var(--surface);\n  border: 1px solid var(--border-strong);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-lg);\n  line-height: 0;\n}\n\n.kiosk-active {\n  justify-content: flex-start;\n  gap: 8px;\n}\n\n.kiosk-active-header {\n  margin-bottom: 12px;\n}\n\n.kiosk-eyebrow {\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  font-size: 13px;\n  color: var(--accent);\n  margin: 0 0 6px;\n}\n\n.kiosk-nickname {\n  font-size: clamp(36px, 5vw, 56px);\n  text-wrap: balance;\n}\n\n.kiosk-queue-note {\n  color: var(--text-faint);\n  font-size: 14px;\n  margin: 6px 0 0;\n}\n\n.kiosk-staff-link {\n  margin-top: 28px;\n  font-size: 12px;\n  color: var(--text-faint);\n  letter-spacing: 0.04em;\n}\n\n.kiosk-staff-link:hover {\n  color: var(--text-muted);\n}\n\n.kiosk-results-idle {\n  margin-top: 12vh;\n}\n\n.kiosk-results {\n  width: 100%;\n}\n\n.kiosk-results .movie-grid.wrap {\n  justify-content: center;\n}\n\n.kiosk-page.panel-open {\n  padding-right: 360px;\n}\n\n.kiosk-panel-toggle {\n  position: fixed;\n  top: 50%;\n  right: 0;\n  z-index: 30;\n  transform: translateY(-50%);\n  writing-mode: vertical-rl;\n  padding: 16px 10px;\n  border: 1px solid var(--border-strong);\n  border-right: none;\n  border-radius: var(--radius-md) 0 0 var(--radius-md);\n  background: var(--surface);\n  color: var(--text);\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  cursor: pointer;\n}\n\n.kiosk-panel-toggle.open {\n  right: 320px;\n  writing-mode: horizontal-tb;\n  padding: 8px 12px;\n}\n\n.kiosk-panel-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 18px;\n  height: 18px;\n  margin-top: 8px;\n  padding: 0 5px;\n  border-radius: var(--radius-full);\n  background: linear-gradient(120deg, var(--accent-start), var(--accent-end));\n  color: #1a0e05;\n  font-size: 11px;\n  writing-mode: horizontal-tb;\n}\n\n.kiosk-panel {\n  position: fixed;\n  top: 0;\n  right: 0;\n  z-index: 25;\n  width: 320px;\n  height: 100vh;\n  height: 100dvh;\n  padding: 22px 18px 28px;\n  background: var(--bg-elevated);\n  border-left: 1px solid var(--border);\n  box-shadow: var(--shadow-lg);\n  transform: translateX(100%);\n  transition: transform 0.2s var(--ease);\n  overflow-y: auto;\n  text-align: left;\n}\n\n.kiosk-panel.open {\n  transform: translateX(0);\n}\n\n.kiosk-panel-head h2 {\n  margin: 0 0 4px;\n  font-size: 20px;\n}\n\n.kiosk-panel-head p {\n  margin: 0 0 18px;\n  color: var(--text-muted);\n  font-size: 13px;\n}\n\n.kiosk-panel-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 22px;\n}\n\n.kiosk-panel-primary,\n.kiosk-panel-danger,\n.kiosk-panel-row button {\n  border: none;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.kiosk-panel-primary {\n  padding: 12px 14px;\n  border-radius: var(--radius-full);\n  background: linear-gradient(120deg, var(--accent-start), var(--accent-end));\n  color: #1a0e05;\n  font-size: 14px;\n}\n\n.kiosk-panel-danger {\n  padding: 10px 14px;\n  border-radius: var(--radius-full);\n  background: var(--dislike-soft);\n  color: var(--dislike);\n  font-size: 13px;\n}\n\n.kiosk-panel-primary:disabled,\n.kiosk-panel-danger:disabled,\n.kiosk-panel-row button:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.kiosk-panel-section {\n  margin-bottom: 20px;\n}\n\n.kiosk-panel-section h3 {\n  margin: 0 0 8px;\n  font-size: 12px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--text-faint);\n}\n\n.kiosk-panel-empty {\n  margin: 0;\n  color: var(--text-faint);\n  font-size: 13px;\n}\n\n.kiosk-panel-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 10px 0;\n  border-bottom: 1px solid var(--border);\n}\n\n.kiosk-panel-row.current strong {\n  color: var(--accent);\n}\n\n.kiosk-panel-row div {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.kiosk-panel-row strong {\n  font-size: 14px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.kiosk-panel-row span {\n  font-size: 12px;\n  color: var(--text-faint);\n}\n\n.kiosk-panel-row button {\n  flex-shrink: 0;\n  padding: 6px 10px;\n  border-radius: var(--radius-full);\n  background: var(--surface-hover);\n  color: var(--text);\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
